import {currentNav} from "./Stores";

// <<<<<<<<<<<<<<<<<<<<<<****************>>>>>>>>>>>>>>>>
export let developmentMode = false
// <<<<<<<<<<<<<<<<<<<<<<****************>>>>>>>>>>>>>>>>

export const WaitlistAPIResponseKeys = {
  success: 'success',
  already_on_waitlist: 'alreadyOnWaitlist',
  bad_image_encoding: 'badImageEncoding',
  failed_dynamo: 'failedDynamo',
  failed_S3: 'failedS3',
  generic_error: 'genericError',
  mediaUploaded: 'mediaUploaded',
  memoryWritten: 'memoryWritten',
  loadedMemories: 'memoryList',
  mediaList: 'mediaList',
  tags: 'tags',
}

export const MemoryManagerViewModel = {
  initial: 'initial',
  submitting: 'submitting',
  refreshing: 'refreshing',
  successfulUpload: 'successfulUpload',
  loaded: 'loaded',
  error: 'error',
}

export function refreshPath() {
  const pathComponents = location.pathname.split('/')
  let first = pathComponents[1]
  switch (first) {
    case '':
    case 'projects':    currentNav.set('projects'); break;
    case 'rates':       currentNav.set('rates'); break;
    case 'rants':       currentNav.set('rants'); break;
    case 'adventures':  currentNav.set('adventures'); break;
    default:
      currentNav.set('');
      break;
  }
}

export function s3linkfrom(uuid) {
  return 'https://s3.us-east-2.amazonaws.com/io.ryancumley.media/' + uuid
}
function urlFor(path) {
  if (developmentMode) { return 'http://localhost:5000/' + path }
  else { return 'https://www.ryancumley.io/' + path }
}
export function push(path) {
  window.history.pushState(
    {thing: 'nothing to see here'},
    '',
    urlFor(path))
  const basePath = path.split('/')[0]
  currentNav.set(basePath)
}

function apiRequest(body, method) {
  let requestBody
  let endpoint

  if (body === null) { //My Lambda wont even try to decode the 'body' element on model enum cases without associated types.
    body = 'nobody! ha!'
  }

  if (developmentMode) {
    requestBody = JSON.stringify(
      {
        "meta":
          {"requestUUID": "dev", "apiVersion": 1, "requestType": method, "site": "ryan"},
        "body": body
      });
    endpoint = 'http://localhost:7000/invoke'
  } else {
    requestBody = JSON.stringify(body);
    endpoint = 'https://api.ryancumley.io'
  }

  return fetch (
    endpoint,
    {
      method: 'POST',
      mode: 'cors',
      credentials: 'omit',
      headers: {
        'Content-Type': 'application/json',
        'Api-Version': 1,
        'Request-Type': method,
        'Site': 'ryan',
      },
      referrerPolicy: 'no-referrer',
      body: requestBody
    }
  ).then(r => r.json())
}

export function loadMemories(list, stateCallback, dataCallback) {
  stateCallback(MemoryManagerViewModel.submitting)
  apiRequest(list, 'loadMemories').then(d => {
    switch (Object.keys(d)[0]) {
      case WaitlistAPIResponseKeys.loadedMemories:
        dataCallback(d[WaitlistAPIResponseKeys.loadedMemories])
        stateCallback(MemoryManagerViewModel.loaded,)
        break

      case WaitlistAPIResponseKeys.failed_S3:
        stateCallback(MemoryManagerViewModel.error)
        break

      default:
        stateCallback(MemoryManagerViewModel.error)
        break
    }
  })
}

//Memory Cache
import {writable} from "svelte/store";
const sessionMemories = writable([])

export const CacheLoadState = {
  loading: 'loading',
  found: 'found',
  failed: 'failed'
}

export function memory(uuid, stateCallback, dataC) {
  let cached = sessionMemories[uuid]
  if (cached != null) {
    dataC(cached)
    stateCallback(CacheLoadState.found)
  } else {
    stateCallback(CacheLoadState.loading)
    loadMemories(
      [uuid],
      (state) => {
        switch (state) {
          case MemoryManagerViewModel.loaded:
            stateCallback(CacheLoadState.found)
            break
          case MemoryManagerViewModel.error:
            stateCallback(CacheLoadState.failed)
            break
        }
      },
      (data) => {
        sessionMemories[uuid] = data[0]
        dataC(data[0])
      }
    )
  }
}

export function preFetchMemories(uuids, stateCallback) {
  stateCallback(CacheLoadState.loading)
  if (sessionMemories.length > 0) {
    stateCallback(CacheLoadState.found)
  } else {
    loadMemories(
      uuids,
      (state) => {
        switch (state) {
          case MemoryManagerViewModel.loaded:
            stateCallback(CacheLoadState.found)
            break
          case MemoryManagerViewModel.error:
            stateCallback(CacheLoadState.failed)
            break
        }
      },
      (data) => {
        data.forEach(memory => sessionMemories[memory['uuid']] = memory)
      }
    )
  }
}
